<template>
  <react-wrapper :component="entrust" :sdkToken="sdkToken" :workflowRunId="workflowRunId" :style="{ height: '100%', overflowY: 'auto' }" />
</template>

<script lang="ts">
import Entrust from '@/react-components/pages/entrust'
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { logWarningToDatadog } from '@/common/utils';
@Component({
  components: {
    ReactWrapper: () => import('@/components/ReactWrapper.vue')
  }
})

export default class EntrustWrapper extends Vue {
  @Prop({ type: String })
  sdkToken?: string;

  @Prop({ type: String })
  workflowRunId?: string;

  get entrust() {
    return Entrust;
  }

  mounted() {
    this.checkRequiredProps();
  }

  private checkRequiredProps() {
    if (!this.sdkToken || !this.workflowRunId) {
      logWarningToDatadog('Entrust page accessed without required parameters. Redirecting to login page', {
        event: 'ENTRUST_MISSING_PARAMETERS',
        sdkToken: this.sdkToken ? 'present' : 'missing',
        workflowRunId: this.workflowRunId,
      })

      this.$router.push('/login');
    }
  }
}
</script>